import {ascendColors} from './GlobalStyles'
import {checkContrastAndReturnBestFontColor} from './helpers'

export const setCustomColors = ({
  primary,
  secondary,
  tertiary,
}: {
  primary: string
  secondary: string
  tertiary: string
}) => {
  const fontOnPrimary = checkContrastAndReturnBestFontColor(primary, secondary)
  const fontOnSecondary = checkContrastAndReturnBestFontColor(
    secondary,
    primary,
  )
  ascendColors.fontOnPrimary = fontOnPrimary
  ascendColors.fontOnSecondary = fontOnSecondary
  ascendColors.customPrimary = primary
  ascendColors.customSecondary = secondary
  ascendColors.customTertiary = tertiary
}
